var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"cascader-menu"},[_c('ul',{staticClass:"cascader-wapper clearfix"},_vm._l((_vm.titles),function(t,i){return _c('li',{key:i,staticClass:"menu-item",class:[{
      'is-disabled': !_vm.lists[i],
      'is-active': i === _vm.current,
    }],on:{"click":function($event){return _vm.titleClick(i)}}},[_vm._v(_vm._s(t))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }